import { render, staticRenderFns } from "./PersonComponent.vue?vue&type=template&id=034bdf86"
import script from "./PersonComponent.vue?vue&type=script&lang=js"
export * from "./PersonComponent.vue?vue&type=script&lang=js"
import style0 from "./PersonComponent.vue?vue&type=style&index=0&id=034bdf86&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports